import React from 'react';

import { useParams, Navigate } from 'react-router-dom';

import Loading from '../../components/Loading';
import Breadcrumb from '../../components/Breadcrumbs';

import Error from '../Error';

import { StyledArticle } from './Article.styled';

import usePages from '../../hooks/usePages';

import { PrismicImage, PrismicRichText } from '@prismicio/react';

const Article = () => {
  const { uid } = useParams();
  const { loading, error, data } = usePages();

  const post = data?.find((el) => {
    return el.uid === uid;
  });

  const options = {
    heading1: ({ children }) => <h1 className="article__title">{children}</h1>,
    paragraph: ({ children }) => <p className="article__desc">{children}</p>,
  };

  return loading ? (
    <Loading />
  ) : error ? (
    <Error error={error} />
  ) : post ? (
    <StyledArticle className="article">
      <Breadcrumb />
      <PrismicImage className="article__image" field={post?.data.image} />
      <PrismicRichText components={options} field={post?.data.title} />
      <PrismicRichText components={options} field={post?.data.intro} />
      <PrismicRichText components={options} field={post?.data.content} />
    </StyledArticle>
  ) : (
    <Navigate to="/error" replace />
  );
};

export default Article;

